import { availableNetworks } from "../config/availableNetworks";
import { notify } from "./notification";
import { changeWeb3AuthChain, web3auth } from "./web3auth";
import store from "../../store/store";
import { erc20ABI } from "../contract_abi/erc20Abi";
import { Contract, ethers } from "ethers";
import { billingManager } from "../contract_abi/billing";
import { getAddress, getLoginType } from "./auth";
import History from "./GlobalNavigation/navigationHistory";

export const getCoinInfo = (coinName: string) => {
  const currentChain = store.getState()?.["currentChain"]?.["currentChain"];

  if (availableNetworks[currentChain + ""]) {
    const chainInfo = availableNetworks[currentChain + ""];
    const coins = chainInfo?.["stableCoins"];
    const coinInfo = coins.filter((coin: any) => coin.name === coinName);
    // console.log(coinInfo, 'ssss')
    return coinInfo.length > 0 ? coinInfo[0] : null;
  } else {
    notify("Please Select Supported Chain", "error");
    changeWeb3AuthChain("ethereum");
    return null;
  }
};

export const getNativeBalance = async () => {
  let loginType = getLoginType();

  let ethProvider = undefined;
  if (loginType === "openlogin") {
    ethProvider = store?.getState()?.["currentProvider"]['web3authProvider'];
  } else {
    ethProvider = store?.getState()?.["currentProvider"]['metamaskProvider'];
  }
  const provider = new ethers.BrowserProvider(ethProvider)
  const address = getAddress();
  if (address) {
    const rawBalance = await provider.getBalance(address);
    const balance = ethers.formatEther(rawBalance);
    return balance
  }
};

export const getCoinBalance = async (coinName: string) => {
  let loginType = getLoginType();
  let ethProvider = undefined;
  if (loginType === "openlogin") {
    ethProvider = store?.getState()?.["currentProvider"]['web3authProvider'];
  } else {
    ethProvider = store?.getState()?.["currentProvider"]['metamaskProvider'];
  }
  let balance: string | number = 0;
  try {
    const coinInfo = getCoinInfo(coinName);

    const ERC20ABI = erc20ABI;
    const provider = new ethers.BrowserProvider(ethProvider)
    const signer = await provider.getSigner();
    const coinContract = new Contract(coinInfo?.contractAddress, ERC20ABI, provider);
    const address = await signer.getAddress();
    const sym = await coinContract.symbol()

    balance = (await coinContract.balanceOf(address)).toString();

    balance = Number(balance);
    balance = balance > 0 ? (balance / 10 ** coinInfo?.decimals).toFixed(1) : 0;
  } catch (error: any) {
    notify(error, "error");
  }
  return balance;
};

export const activateBillingSubscription = async (
  coinName: string,
  planID: string,
  setIsloading: (isLoading: boolean) => void
) => {
  setIsloading(true);
  try {
    let loginType = getLoginType();
    let ethProvider = undefined;
    const coinInfo = getCoinInfo(coinName);
    const ERC20ABI = erc20ABI;
    const currentChain = store.getState()?.["currentChain"]?.["currentChain"];

    if (loginType === "openlogin") {
      ethProvider = store?.getState()?.["currentProvider"]['web3authProvider'];
    } else {
      ethProvider = store?.getState()?.["currentProvider"]['metamaskProvider'];
    }
    const provider = new ethers.BrowserProvider(ethProvider)

    const signer = await provider.getSigner();
    const coinContract = new ethers.Contract(
      coinInfo?.contractAddress,
      ERC20ABI,
      signer
    );

    const billingContract = new ethers.Contract(
      billingManager.contractAddress[currentChain as 'polygon' | 'base' | 'fvm'],
      billingManager["abi"],
      signer
    );

    const feeData = await provider.getFeeData();

    const billingData = await billingContract.purchasePlan(
      planID,
      coinContract.target,
      { gasPrice: feeData.gasPrice }
    );


    await billingData.wait();
    setIsloading(false);
    notify(
      "Transaction Sucess : It can take few minutes for plan to get activated",
      "success"
    );
    
  } catch (error: any) {
    setIsloading(false);

    notify(
      error["message"]
        ? error["message"]
        : "Something Went Wrong ! Please Try Again",
      "error"
    );
  }
};


export const approveERC20Token = async (
  coinName: string,
  planID: string,
  setIsloading: (isLoading: boolean) => void
) => {
  setIsloading(true);
  try {
    let loginType = getLoginType();
    let ethProvider = undefined;
    const coinInfo = getCoinInfo(coinName);
    const ERC20ABI = erc20ABI;
    const currentChain = store.getState()?.["currentChain"]?.["currentChain"];
    if (loginType === "openlogin") {
      ethProvider = store?.getState()?.["currentProvider"]['web3authProvider'];
    } else {
      ethProvider = store?.getState()?.["currentProvider"]['metamaskProvider'];
    }
    const provider = new ethers.BrowserProvider(ethProvider)
    const signer = await provider.getSigner();
    const coinContract = new ethers.Contract(
      coinInfo?.contractAddress,
      ERC20ABI,
      signer
    );
    const billingContract = new ethers.Contract(
      billingManager.contractAddress[currentChain as 'polygon' | 'base' | 'fvm'],
      billingManager["abi"],
      signer
    );
    const { totalValue } = await billingContract.getPayableAmount(
      coinContract.target,
      planID
    );
    // console.log('total value',totalValue);
    const feeData1 = await provider.getFeeData();
    const approvalData = await coinContract.approve(
      billingContract.target,
      totalValue,
      { gasPrice: feeData1.gasPrice }
    );
    await approvalData.wait();
    setIsloading(false);
    notify('Token approved! You can now proceed with payment.', 'success');
    return true;
  } catch (error) {
    notify('Cant Approve Token, Please Try Again', 'error');
    setIsloading(false);
    return false;
  }
}

export const checkApprovedToken = async (
  coinName: string,
  planID: string,
  setIsloading: (isLoading: boolean) => void
) => {
  setIsloading(true);
  try {
    const loginType = getLoginType();
    let ethProvider = undefined;
    const coinInfo = getCoinInfo(coinName);
    const ERC20ABI = erc20ABI;
    const currentChain = store.getState()?.["currentChain"]?.["currentChain"];

    if (loginType === "openlogin") {
      ethProvider = store?.getState()?.["currentProvider"]['web3authProvider'];
    } else {
      ethProvider = store?.getState()?.["currentProvider"]['metamaskProvider'];
    }

    const provider = new ethers.BrowserProvider(ethProvider);
    const signer = await provider.getSigner();
    const userAddress = await signer.getAddress();

    const coinContract = new ethers.Contract(
      coinInfo?.contractAddress,
      ERC20ABI,
      signer
    );

    const billingContract = new ethers.Contract(
      billingManager.contractAddress[currentChain as 'polygon' | 'base' | 'fvm'],
      billingManager["abi"],
      signer
    );

    const { totalValue } = await billingContract.getPayableAmount(
      coinContract.target,
      planID
    );

    const allowance = await coinContract.allowance(
      userAddress,            
      billingContract.target   
    );

    // console.log(`Allowance: ${ethers.formatUnits(allowance, coinInfo?.decimals)} ${coinInfo?.abb}`);
    // console.log(`Required: ${ethers.formatUnits(totalValue, coinInfo?.decimals)} ${coinInfo?.abb}`);

    setIsloading(false);

    // Return true if already approved enough
    return allowance >= totalValue;

  } catch (error) {
    console.error('Error checking approved token:', error);
    notify('Cant Check Token Approval, Please Try Again', 'error');
    setIsloading(false);
    return false;
  }
};